/**
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import { Attribute, Directive, ElementRef, InjectionToken, Input } from '@angular/core';

let nextUniqueId = 0;
/**
 * Injection token that can be used to reference instances of `MatError`. It serves as
 * alternative token to the actual `MatError` class which could cause unnecessary
 * retention of the class and its directive metadata.
 */
export const FORM_ERROR = new InjectionToken<SFormError>('FormError');
/** Single error message to be shown underneath the form-field. */
@Directive({
  selector: 's-form-error-message, [formError]',
  host: {
    class: 'form-error',
    'aria-atomic': 'true',
    '[id]': 'id'
  },
  standalone: true,
  providers: [{ provide: FORM_ERROR, useExisting: SFormError }]
})
// eslint-disable-next-line @angular-eslint/directive-class-suffix
export class SFormError {
  @Input() id = `mat-mdc-error-${nextUniqueId++}`;
  constructor(@Attribute('aria-live') ariaLive: string, elementRef: ElementRef) {
    // If no aria-live value is set add 'polite' as a default. This is preferred over setting
    // role='alert' so that screen readers do not interrupt the current task to read this aloud.
    if (!ariaLive) {
      elementRef.nativeElement.setAttribute('aria-live', 'polite');
    }
  }
}
